import shortid from 'shortid';
import FilterAdapter from '@/components/query/adapters/filter/filter-adapter';
import segmentFilters from './segment-filters';

/** @module Segment */

/**
 * Class representing a Segment. A Segment is a container for a Filter.
 */
export default class Segment {
    id = null;

    name = null;

    filter = null;

    /**
     * @param id How the Segment is referred within code
     * @param name Name of the Segment which will be displayed on the Dashboard and in Metrics cards
     * @param filter The Filter that this class encapsulates
     */
    constructor({id = shortid.generate(), name = null, filter = null} = {}) {
        if (id === null) {
            throw new Error('Cannot instantiate a segment with no id');
        }
        this.id = id;
        this.name = name;
        this.filter = filter;
    }

    /**
     * Return properties of the Segment.
     *
     * @returns {{id: *, name: *, filter: *}}
     */
    getProps() {
        return {
            id: this.id,
            name: this.name,
            filter: this.filter,
        };
    }

    /**
     * Return in a storeable format.
     *
     * @returns {Object}
     */
    getNormalized() {
        return {
            [this.id]: this.getProps(),
        };
    }

    /**
     * Return the Segment and encapsulated Filter which will then be passed to API queries.
     *
     * @returns {{name: *, filter: *}}
     */
    getPayload() {
        let filter = null;
        if (this.filter !== null && Array.isArray(this.filter)) {
            const query = this.filter;
            filter = FilterAdapter.convertFiltersToString({
                filterSet: segmentFilters.filters,
                query,
            });
        }
        return {
            name: this.name,
            filter,
        };
    }
}
